import {
  AnyChainId,
  ARBITRUM,
  ARBITRUM_SEPOLIA,
  AVALANCHE,
  AVALANCHE_FUJI,
  BOTANIX,
  CONTRACTS_CHAIN_IDS as SDK_CONTRACTS_CHAIN_IDS,
  CONTRACTS_CHAIN_IDS_DEV as SDK_CONTRACTS_CHAIN_IDS_DEV,
  SettlementChainId,
  SOURCE_BASE_MAINNET,
  SOURCE_BSC_MAINNET,
  SOURCE_ETHEREUM_MAINNET,
  SOURCE_OPTIMISM_SEPOLIA,
  SOURCE_SEPOLIA,
} from "sdk/configs/chains";

import { isDevelopment } from "./env";

export * from "sdk/configs/chains";

export const CONTRACTS_CHAIN_IDS: readonly number[] = isDevelopment()
  ? SDK_CONTRACTS_CHAIN_IDS_DEV
  : SDK_CONTRACTS_CHAIN_IDS;

export const DEFAULT_SETTLEMENT_CHAIN_ID: SettlementChainId = isDevelopment() ? ARBITRUM_SEPOLIA : ARBITRUM;

export const DEFAULT_SETTLEMENT_CHAIN_ID_MAP: Record<AnyChainId, SettlementChainId> = {
  [ARBITRUM_SEPOLIA]: ARBITRUM_SEPOLIA,
  [SOURCE_OPTIMISM_SEPOLIA]: ARBITRUM_SEPOLIA,
  [SOURCE_SEPOLIA]: ARBITRUM_SEPOLIA,
  [SOURCE_ETHEREUM_MAINNET]: ARBITRUM,
  [SOURCE_BASE_MAINNET]: ARBITRUM,
  [SOURCE_BSC_MAINNET]: ARBITRUM,
  [BOTANIX]: ARBITRUM,

  // Stubs
  [ARBITRUM]: ARBITRUM, // ARBITRUM,
  [AVALANCHE]: ARBITRUM, // AVALANCHE,
  [AVALANCHE_FUJI]: ARBITRUM_SEPOLIA,
};
